import AddHoldingForm from "./add-holding-form";

export default AddHoldingForm;
